export type EventsCalendarViewType = 'calendar' | 'table';

/** Maps `view` query param to internal view type. */
export function parseEventsCalendarViewFromUrl(
  viewParam: string | undefined
): EventsCalendarViewType {
  return viewParam?.toLowerCase() === 'list' ? 'table' : 'calendar';
}

export function eventsCalendarViewToUrlParam(
  viewType: EventsCalendarViewType
): 'list' | 'calendar' {
  return viewType === 'table' ? 'list' : 'calendar';
}
